import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import SupportCard from "./SupportCard";
import { useNavigate } from "react-router-dom";
import { ListTicket } from "../../services/ticket/ticket";
import { useTranslation } from "react-i18next";

function Support() {
  const { t } = useTranslation();
  const [deviceData, setDeviceData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await ListTicket();
      setDeviceData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching device data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Box className="p-3 mb-24" >
        {isLoading ? (
          <Box
            sx={{
              height: "50vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color="primary" size={70} />
          </Box>
        ) : (
          <AnimatePresence>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            ></Box>

            {deviceData.map((device, index) => (
              <motion.div
                key={device.title + index}
                initial={{ opacity: 0, x: 10 }} // Initial animation state (fade in + slide from bottom)
                animate={{ opacity: 1, x: 0 }} // Animation on mount
                exit={{ opacity: 0, x: -10 }} // Exit animation on unmount (fade out + slide up)
                transition={{
                  duration: 0.5, // Enter animation duration
                  delay: 0.2 * index, // Add a delay for each subsequent item based on its index
                }}
              >
                <SupportCard
                  title={device.title}
                  comment={device.comment}
                  status={device.status}
                  idstrticket={device.idstrticket}
                  datesabt={device.datesabt}
                />
              </motion.div>
            ))}
          </AnimatePresence>
        )}
        <Box
          sx={{
            position: "fixed",
            left: 0,
            right: 0,
            bottom: "6.5rem", // Place above nav
            display: "flex",
            px:3,
            zIndex: 12,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={() => navigate("/ticket")}
            sx={{
              padding: "15px 20px",
              borderRadius: "15px",
              border: "1px solid white",
            }}
          >
            {t("Support.Ticket")}
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Support;
